import isAnalyticsAllowed from '@/lib/isAnalyticsAllowed';
import { PostHogErrorBoundary, PostHogProvider } from 'posthog-js/react';

const PostHogWrapper = ({ children }) => {
  const postHogApiKey = 'phc_aW977QdPvipUCuBpG1aNehQeOhziqBu9YA6MCzYRuy4';
  const postHogOptions = { api_host: 'https://hog.mindcloud.co' };

  if (isAnalyticsAllowed) {
    return (
      <PostHogProvider apiKey={postHogApiKey} options={postHogOptions}>
        <PostHogErrorBoundary fallback={<span />}>{children}</PostHogErrorBoundary>
      </PostHogProvider>
    );
  }

  return children;
};

export default PostHogWrapper;
